<template>
<div class="main">
  <div id="card" class="card">
    <h6 class="card-header">Programmers</h6>
    <div class="card-body prog-container">
      <b-table responsive small :sort-by="'prog'" :items="items" :fields="fields">

        <template slot="actions" slot-scope="row">
          <b-button variant="danger" size="sm" @click="showDeleteModal(row.index)" class="mr-1" style="padding-left:10px;padding-right:10px">
            Delete
          </b-button>
        </template>

      </b-table>
    </div>
  </div>

  <div id="card" class="card">
    <h6 class="card-header">Insert Programmer</h6>
    <div class="card-body">
      <b-container>
        <b-row align-h="start">
          <b-col>
            <b-form-input class="input" v-model="prog" placeholder="Programmer" />
          </b-col>
          <b-col>
            <div class="">
              <button type="button" v-on:click="addProg()" class="btn btn-dark">
                Add
              </button>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container>
    </div>
  </div>

  <div>
    <b-modal ref="my-modal" hide-footer hide-header title="Using Component Methods">
      <div class="d-block text-center">
          <p>Are you sure you want to delete this programmer?</p>
      </div>
      <div class="d-flex w-100 justify-content-center">
        <b-button size="sm" variant="outline-secondary" @click="toggleModal" style="margin-right:4%">Cancel</b-button>
        <b-button size="sm" variant="outline-danger" @click="deleteRow()" style>Proceed</b-button>
      </div>
    </b-modal>
  </div>

</div>
</template>
<script>
export default {
  created() {
    this.$overlay.show(this);
    this.$api.getProgs().then((response) => {
      if (response.status == 200) {
        this.items = response.data;
      }
      this.$overlay.hide();
    }).catch(error => {
      this.$overlay.hide();
    })
  },
  data: () => ({
    prog: '',
    fields: [
      {
        key:'prog',
        label:'ID'
      },
      {
        key:'actions',
        label:'Actions'
      }

    ],
    items: [

    ],
    deleteIndex:-1

  }),
  methods: {
    toggleModal() {
        this.$refs['my-modal'].toggle('#toggle-btn')
    },
    showDeleteModal(index){
      this.deleteIndex = index;
      this.toggleModal();
    },
    addProg() {
      if (this.prog != '') {
        this.$overlay.show(this);
        this.$api.addProg(this.prog).then((response) => {
          if (response.status == 202) {
            if (this.prog != '') {
              this.$toasted.success("Programmer added.").goAway(1200);
              this.items.push({
                'prog': this.prog
              });
              this.prog = '';
            }
          }
          this.$overlay.hide();
        }).catch(error => {
          this.$overlay.hide();
          if (error.response.status == 404) {
            this.$toasted.error("Programmer already exists.").goAway(1200);
          }
        });
      }
    },

    deleteRow(){
      this.$overlay.show(this);
      this.$api.deleteProg(this.items[this.deleteIndex].prog).then((response) => {
        if(response.status == 202){
          this.items.splice(this.deleteIndex,1);
          this.$toasted.success("Programmer deleted.").goAway(1200);
        }
        this.$overlay.hide();
      }).catch(error => {
        this.$toasted.error(error.response.data.message).goAway(1200);
        this.$overlay.hide();
      })
      this.toggleModal();
    }

  }
}
</script>
<style lang="css" scoped>


.input{
  padding-left: 2%;
  padding-right: 5%;
  max-width: 300px;

}

.card-header{
  color: white;
  background-color:#2a2a2e;
}


button{
  padding-left: 4%;
  padding-right: 4%;
}

.main{
  width:100%;
  height: 100%;
}

.prog-container{
  max-height: 300px;
  overflow-y: auto;
}

.card-header{
  text-align: left;
}


</style>
